import { api, axios, Core, Env, Match, TMatchContentProps } from "@ancademy/vse-client";
import { ErrorMsg, IStudentInfo, MS, Role, TSafeUser } from "@ancademy/vse-share";
import { Background, Color, ColorDerived, Style } from "@client";
import { css, cx } from "@emotion/css";
import { Const } from "@share";
import { Divider, Form, Input, message, Modal, Space } from "antd";
import moment from "moment";
import { rgba } from "polished";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const titleStyle = css`
  color: ${Color.main};
  width: 100%;
  text-align: center;
  font-size: 2rem;
  padding-bottom: 1.6rem;
  margin-bottom: 1.6rem;
`;
const inputItem = css`
  color: ${Color.main};
  height: 4rem;
  font-size: 2rem;
  line-height: 4.8rem;
  padding-bottom: 1rem;
  width: 3rem;
  position: relative;
  text-align: center;

  &::after {
    content: " ";
    width: 3rem;
    height: 0.4rem;
    border-radius: 0.3rem;
    background-color: #dce6e3;
    position: absolute;
    bottom: 0;
    left: 0;
  }
`;
const keyBordData = [1, 2, 3, 4, 5, 6, 7, 8, 9, "重置", 0, "删除"];

function MatchContent({ status, matchTimer, mainGameId, fnMatch, fnRematch }: TMatchContentProps) {
  switch (status) {
    case MS.PlayerStatus.init:
      return (
        <button className={Style.btnPrimary} onClick={fnMatch}>
          新的实验
        </button>
      );
    case MS.PlayerStatus.matching:
      return <p>匹配中，预计{matchTimer}秒...</p>;
    case MS.PlayerStatus.matched:
      return (
        <Space>
          <button className={Style.btnPrimarySm} onClick={fnRematch}>
            重新开始
          </button>
          <button className={Style.btnPrimarySm} onClick={() => (location.href = `${Env.basePath}/play/${mainGameId}`)}>
            进入实验
          </button>
        </Space>
      );
  }
}

export function Lobby({ historyMainGameList, user }: Core.ILobbyProps) {
  const navigate = useNavigate();
  const [password, setPassword] = useState(new Array(6).fill(undefined));
  return (
    <div
      className={css`
        height: 100vh;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
      `}
    >
      <Background />
      <button
        className={cx(
          Style.btn,
          css`
            position: fixed;
            top: 1rem;
            left: 1rem;
          `
        )}
        onClick={async () => {
          await api.logout();
          location.href = Env.basePath;
        }}
      >
        退出
      </button>
      <section
        className={css`
          box-shadow: ${Style.shadowNormal};
        `}
      >
        <div
          className={css`
            background: #f8fef8;
            width: 100%;
            display: flex;
            border-radius: 1.6rem;
          `}
        >
          <div
            className={css`
              display: flex;
              flex-flow: column;
              min-width: 48rem;
              align-items: center;
              overflow: auto;
              margin-top: 4rem;
              margin-bottom: 2.8rem;
              position: relative;

              &::-webkit-scrollbar {
                width: 0.8rem;
              }

              &::-webkit-scrollbar-track {
                background-color: #e1ede7;
                border-radius: 0.4rem;
              }

              &::-webkit-scrollbar-thumb {
                background-color: #47a593;
                border-radius: 0.4rem;
              }
            `}
          >
            <h1
              className={cx(
                titleStyle,
                css`
                  background-color: #f8fef8;
                  position: sticky;
                  top: 0;
                `
              )}
            >
              最近实验
            </h1>
            <ul
              className={css`
                padding: 0 2rem;
              `}
            >
              {historyMainGameList.slice(0, 3).map(({ id, title, createdAt }, i) => (
                <li>
                  {i > 0 && (
                    <Divider
                      className={css`
                        margin: 1rem 0 !important;
                        color: #e9e9e9;
                      `}
                    />
                  )}
                  <Space size={40} align={"center"}>
                    <div
                      className={css`
                        width: 24rem;
                        color: ${ColorDerived.darkMain};
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        font-size: 1.5rem;
                      `}
                    >
                      {title}
                    </div>
                    <a className={Style.btnLink} onClick={() => navigate(`/play/${id}`)}>
                      进入实验
                    </a>
                  </Space>
                  <div
                    className={css`
                      text-align: right;
                      color: rgba(91, 91, 91, 0.4);
                      font-size: 1.5rem;
                      line-height: 2.8rem;
                      margin-top: 0.5rem;
                    `}
                  >
                    {moment(createdAt).format(moment.HTML5_FMT.DATETIME_LOCAL)}
                  </div>
                </li>
              ))}
              <div
                className={css`
                  display: flex;
                  justify-content: center;
                  margin: 2rem;
                `}
              >
                {user.role === Role.student ? null : <Match>{MatchContent}</Match>}
              </div>
            </ul>
          </div>
          <Divider
            type={"vertical"}
            className={css`
              margin: 0 1.6rem 1.6rem !important;
              color: #e7f5ee;
              height: 100%;
            `}
          />
          <Space
            direction="vertical"
            size={0}
            className={css`
              align-items: center;
              display: flex;
              width: 36rem;
              margin: 3.6rem auto;
            `}
          >
            <h2 className={titleStyle}>
              输入邀请码
              <span
                className={css`
                  padding-left: 1rem;
                  font-size: 1.5rem;
                `}
              >
                (加入指定场次)
              </span>
            </h2>
            <Space size={24}>
              {password.map((it, index) => (
                <div className={cx(inputItem)} key={index}>
                  {it}
                </div>
              ))}
            </Space>
            <div
              className={css`
                margin-top: 4rem;
                display: flex;
                flex-wrap: wrap;
                justify-content: center;
              `}
            >
              {keyBordData.map((it) => (
                <div
                  className={css`
                    width: 10rem;
                    flex-grow: 0;
                    height: 6rem;
                    margin-right: 0.4rem;
                    margin-bottom: 0.4rem;
                    display: flex;
                    border-radius: 0.4rem;
                    justify-content: center;
                    cursor: pointer;
                    align-items: center;
                    user-select: none;
                    transition: all 0.2s linear;

                    &:hover {
                      background-color: ${rgba(Color.main, 0.2)};
                      transform: scale(1.1);
                    }
                  `}
                  onClick={async () => {
                    const newArr = new Array(6).fill(undefined);
                    if (typeof it === "number") {
                      for (let i = 0; i < password.length; i++) {
                        if (password[i] === undefined) {
                          newArr[i] = it;
                          break;
                        } else {
                          newArr[i] = password[i];
                        }
                      }
                    } else if (it === "delete") {
                      for (let i = 0; i < password.length; i++) {
                        if (password[i + 1] === undefined) {
                          newArr[i] = undefined;
                          break;
                        } else {
                          newArr[i] = password[i];
                        }
                      }
                    }
                    setPassword(newArr);
                    if (newArr.some((d) => d === undefined)) {
                      return;
                    }
                    try {
                      const mainGame = await api.getMainGameByPassword(newArr.join(""));
                      navigate(`/play/${mainGame.id}`);
                    } catch (err) {
                      switch (err) {
                        case ErrorMsg.MAIN_GAME_NOT_FOUND:
                          message.warn("邀请码不存在，请检查输入！");
                          break;
                      }
                    }
                  }}
                >
                  <div
                    className={css`
                      color: ${Color.main};
                      line-height: 4rem;
                      font-size: 2rem;
                    `}
                  >
                    {it}
                  </div>
                </div>
              ))}
            </div>
            `
          </Space>
        </div>
      </section>
      <LobbySchoolInfoModal />
    </div>
  );
}

function LobbySchoolInfoModal() {
  const [user, setUser] = useState(null as TSafeUser & { school: string });
  const ItemKey = {
    school: "school",
  };
  const [form] = Form.useForm<IStudentInfo>();
  useEffect(() => {
    api.getUser().then((user: any) => user && setUser(user));
  }, []);
  if (!user) {
    return null;
  }
  console.log(user);
  return (
    <Modal
      title="请先完善您的身份信息："
      closeIcon={<></>}
      centered
      okText="提交"
      visible={!(user.username.startsWith(Const.casUsernamePrefix) || user.role !== Role.student || user.school)}
      cancelButtonProps={{ hidden: true }}
      onOk={async () => {
        try {
          await form.validateFields();
        } catch (err) {
          message.error("请检查您的输入！");
          return;
        }
        const input = form.getFieldsValue();
        try {
          const res = await axios.put(`${Env.basePath}/extra/school/setSchool/${user.id}`, input);
          const newUser = res.data;
          newUser && setUser(newUser);
        } catch (err) {
          message.error("未知错误，提交失败！");
        }
      }}
    >
      <Form form={form} labelCol={{ span: 6 }} wrapperCol={{ span: 12 }}>
        <Form.Item label="学校" name={ItemKey.school} rules={[{ required: true, message: "请检查您的输入！" }]}>
          <Input maxLength={32} />
        </Form.Item>
      </Form>
    </Modal>
  );
}
